import { useAuth } from "../context/authContext";
import { useEffect, useEffectEvent, useRef, useState } from "react";
import {
  Appid,
  BaseUrl,
  bscRPC,
  bscRPCBalance,
  Imei,
  LoginTypeID,
  SerialNo,
  socketApi,
  socketUrl,
  Version,
} from "../enum/enum";
import axios from "axios";
import Layout from "../layout/layout";
import { toast } from "react-toastify";
import Web3 from "web3";
import { useLoader } from "../context/loaderContext";
import { Link, useNavigate } from "react-router-dom";

const USDT_ABI = require("../../files/contract/usdtAbi.json");
const USDT_Contract_Add = "0x55d398326f99059fF775485246999027B3197955";
let debounceId = null;

const Dashboard = () => {
  const {
    name,
    mobile,
    token,
    sessionId,
    prefix,
    userId,
    accountId,
    setToken,
  } = useAuth();
  const { showLoader, hideLoader } = useLoader();
  const navigate = useNavigate();

  const referralCode = `${window.location.origin}/signup/${prefix}${userId}`;

  const bscParams = {
    chainId: "0x38", // 56 in hex
    chainName: "Binance Smart Chain",
    nativeCurrency: {
      name: "BNB",
      symbol: "BNB",
      decimals: 18,
    },
    rpcUrls: ["https://bsc-dataseed.binance.org/"],
    blockExplorerUrls: ["https://bscscan.com/"],
  };

  const [dashboardData, setDashboardData] = useState({});
  const [networkDashboard, setNetworkDashboard] = useState([]);
  const [packageList, setPackageList] = useState([]);
  const [balanceData, setBalanceData] = useState([]);
  const [selectedOperator, setSelectedOperator] = useState({});
  const [selectedPackage, setSelectedPackage] = useState({});
  const [message1, setMessage1] = useState("");
  const [message, setMessage] = useState("");
  const [sectionLoader, setSectionLoader] = useState(false);
  const [showAddMoney, setShowAddMoney] = useState(false);
  const [showWithdrawal, setShowWithdrawal] = useState(false);
  const [withdrawServiceId, setWithdrawServiceId] = useState(false);
  const [withdrawFromWalletId, setWithdrawFromWallet] = useState(false);
  const [withdrawToWalletId, setWithdrawToWallet] = useState(false);
  const [isAddMoneyEnable, setIsAddMoneyEnable] = useState(false);
  const [addMoneyAmount, setAddMoneyAmount] = useState("");
  const [withDrawalAmt, setWithDrawalAmt] = useState("");
  const [withExternalWallet, setWithExternalWallet] = useState("");
  const [sponsorName, setSponsorName] = useState("");
  const [withDrawalUserId, setWithDrawalUserId] = useState("");
  const [withDrawalError, setWithDrawalError] = useState({});
  const [withDrawalFromCurrencyId, setWithDrawalFromCurrencyId] = useState("");
  const [isManualRequest, setIsManualRequest] = useState(false);
  const [isRankWiseTargetDetail, setIsRankWiseTargetDetail] = useState(false);
  const [rankWiseTargetDetail, setRankWiseTargetDetail] = useState([]);
  const [paymentBanks, setPaymentBanks] = useState([]);
  const [proofDoc, setProofDoc] = useState("");
  const [pkgAmt, setPkgAmt] = useState("");
  const [amtErrorMsg, setAmtErrorMsg] = useState("");
  const [utrNo, setUtrNo] = useState("");
  const [showExternalWallet, setShowExternalWallet] = useState(false);
  const [rankList, setRankList] = useState([]);
  const [dashboardUserAndBalanceData, setDashboardUserAndBalanceData] =
    useState();

  useEffect(() => {
    getDashboardUserAndBalanceData();
  }, []);

  const backToInitial = () => {
    setIsManualRequest(false);
    setAddMoneyAmount("");
    setUtrNo("");
    setProofDoc("");
  };

  const getDashboardData = async () => {
    try {
      // const url = `${BaseUrl}Dashboard/BindNetworkDashboard`;
      const url = `${BaseUrl}Dashboard/MataMaskDashboard`;

      const obj = {
        appid: Appid,
        imei: Imei,
        loginTypeID: LoginTypeID,
        regKey: "",
        serialNo: SerialNo,
        session: token,
        sessionID: sessionId,
        userID: userId,
        version: Version,
      };
      setSectionLoader(true);
      // showLoader();

      const res = await axios.post(url, obj);

      if (res.data.statuscode == 1) {
        setDashboardData(res.data.data);
        localStorage.setItem("dashboardData", JSON.stringify(res.data.data));
        localStorage.setItem("isTopUp", res.data.data?.isTopup);
        localStorage.setItem("inActive", res.data.data?.inActive);
      }

      // hideLoader();
      setSectionLoader(false);
    } catch (e) {
      // hideLoader();
      setSectionLoader(false);
      console.log(e.message);
    }
  };

  const getNetworkDashboard = async () => {
    try {
      const url = `${BaseUrl}Dashboard/BindNetworkDashboard`;

      const obj = {
        appSession: {
          appid: Appid,
          imei: Imei,
          loginTypeID: LoginTypeID,
          regKey: "",
          serialNo: SerialNo,
          session: token,
          sessionID: sessionId,
          userID: userId,
          version: Version,
        },
        Request: {
          FromDate: "1970-01-01T00:00:00",
          ToDate: new Date(),
          appSession: true,
        },
      };

      setSectionLoader(true);
      // showLoader();

      const res = await axios.post(url, obj);

      if (res.data.statuscode == 1) {
        setNetworkDashboard(res.data.data.teamDetailsList);
      }

      // hideLoader();
      setSectionLoader(false);
    } catch (e) {
      // hideLoader();
      setSectionLoader(false);
      console.log(e.message);
    }
  };

  const getAppBalance = async () => {
    try {
      const url = `${BaseUrl}App/v2/GetBalance`;

      const obj = {
        appid: Appid,
        imei: Imei,
        loginTypeID: LoginTypeID,
        regKey: "",
        serialNo: SerialNo,
        session: token,
        sessionID: sessionId,
        userID: userId,
        version: Version,
      };
      // showLoader();

      const res = await axios.post(url, obj);

      if (res.data.statuscode == 1) {
        setBalanceData(res.data.balanceData || []);
        setIsAddMoneyEnable(res.data.isAddMoneyEnable);
      }

      // hideLoader();
    } catch (e) {
      // hideLoader();
      console.log(e.message);
    }
  };

  const getRankList = async () => {
    try {
      const url = `${BaseUrl}App/GetRankList`;

      const obj = {
        appid: Appid,
        imei: Imei,
        loginTypeID: LoginTypeID,
        regKey: "",
        serialNo: SerialNo,
        session: token,
        sessionID: sessionId,
        userID: userId,
        version: Version,
      };
      // showLoader();

      const res = await axios.post(url, obj);

      if (res.data.statuscode == 1) {
        setRankList(res.data.data || []);
      }
      // hideLoader();
    } catch (e) {
      // hideLoader();
      console.log(e.message);
    }
  };

  const getRankwiseTargetDetailsApp = async (rankid) => {
    try {
      const url = `${BaseUrl}App/GetRankwiseTargetDetailsApp`;

      const obj = {
        appSession: {
          appid: Appid,
          imei: Imei,
          loginTypeID: LoginTypeID,
          regKey: "",
          serialNo: SerialNo,
          session: token,
          sessionID: sessionId,
          userID: userId,
          version: Version,
        },
        request: rankid,
      };
      showLoader();

      const res = await axios.post(url, obj);

      if (res.data.statuscode == 1) {
        setRankWiseTargetDetail(res.data.data || []);
        setIsRankWiseTargetDetail(true);
      }
      hideLoader();
    } catch (e) {
      hideLoader();
      console.log(e.message);
    }
  };

  const getOperatorList = async () => {
    try {
      const url = `${BaseUrl}API/GetOperatorListByOperatorType`;

      const obj = {
        // "appSession": {
        appid: Appid,
        imei: Imei,
        loginTypeID: LoginTypeID,
        regKey: "",
        serialNo: SerialNo,
        session: token,
        sessionID: sessionId,
        userID: userId,
        version: Version,
        // }
      };

      showLoader();

      const res = await axios.post(url, obj);

      if (res.data) {
        const selectedOp = res.data[0];
        if (selectedOp) {
          setSelectedOperator(selectedOp);
          // bindPackageByOPID(selectedOp.oid);
          getPackageListFromDb(selectedOp.oid);
        }
      }

      hideLoader();
    } catch (e) {
      hideLoader();
      console.log(e.message);
    }
  };

  const getPackageListFromDb = async (oid) => {
    try {
      showLoader();

      // const url = `${socketApi}getPackageList?oid=${oid}`;

      // const res = await axios.get(url);

      let res = {};
      res.data = {};
      res.data.flag = true;
      res.data.message = [
        {
          packageId: 2,
          packageName: "Unit One",
          productCount: 1,
          packageCost: 20,
          packageCurrencyId: 26,
          oid: 9304,
        },
        {
          packageId: 3,
          packageName: "Unit Two",
          productCount: 2,
          packageCost: 40,
          packageCurrencyId: 26,
          oid: 9304,
        },
        {
          packageId: 4,
          packageName: "Unit Three",
          productCount: 3,
          packageCost: 60,
          packageCurrencyId: 26,
          oid: 9304,
        },
        {
          packageId: 5,
          packageName: "Unit Four",
          productCount: 4,
          packageCost: 80,
          packageCurrencyId: 26,
          oid: 9304,
        },
        {
          packageId: 6,
          packageName: "Unit Five",
          productCount: 5,
          packageCost: 100,
          packageCurrencyId: 26,
          oid: 9304,
        },
        {
          packageId: 2,
          packageName: "Unit One",
          productCount: 1,
          packageCost: 20,
          packageCurrencyId: 26,
          oid: 9303,
        },
        {
          packageId: 3,
          packageName: "Unit Two",
          productCount: 2,
          packageCost: 40,
          packageCurrencyId: 26,
          oid: 9303,
        },
        {
          packageId: 4,
          packageName: "Unit Three",
          productCount: 3,
          packageCost: 60,
          packageCurrencyId: 26,
          oid: 9303,
        },
        {
          packageId: 5,
          packageName: "Unit Four",
          productCount: 4,
          packageCost: 80,
          packageCurrencyId: 26,
          oid: 9303,
        },
        {
          packageId: 6,
          packageName: "Unit Five",
          productCount: 5,
          packageCost: 100,
          packageCurrencyId: 26,
          oid: 9303,
        },
      ].filter((el) => el.oid == oid);

      if (res.data.flag) {
        setPackageList(res.data.message || []);
        if (res.data.message.length === 1) {
          setSelectedPackage(res.data.message[0]);
        }
        if (res.data.message.length == 0) {
          bindPackageByOPID(oid);
        }
      }
      hideLoader();
    } catch (e) {
      hideLoader();
      // console.log("Error on bal get: ", e);
    }
  };

  const bindPackageByOPID = async (oid) => {
    try {
      const url = `${BaseUrl}API/BindPackageByOPID`;

      const obj = {
        loginTypeID: LoginTypeID,
        UserID: userId,
        LoginID: sessionId,
        OPID: oid,
        MetamaskAdd: "",
      };

      showLoader();

      const res = await axios.post(url, obj);

      if (res.data) {
        setPackageList(res.data || []);
        if (res.data.length === 1) {
          setSelectedPackage(res.data[0]);
        }
      }

      hideLoader();
    } catch (e) {
      hideLoader();
      console.log(e.message);
    }
  };

  const getDashboardUserAndBalanceData = async () => {
    try {
      const url = `${BaseUrl}Dashboard/GetManualContract`;

      const obj = {
        appid: Appid,
        imei: Imei,
        loginTypeID: LoginTypeID,
        regKey: "",
        serialNo: SerialNo,
        session: token,
        sessionID: sessionId,
        userID: userId,
        version: Version,
      };

      const res = await axios.post(url, obj);

      if (res.data.statuscode == 1) {
        setDashboardUserAndBalanceData(res.data.data);
      }
    } catch (e) {
      console.log(e.message);
    }
  };

  const handlePackage = (e) => {
    const { value } = e.target;
    setAmtErrorMsg("");
    if (value) {
      const selectedPk = packageList.find((p) => p.packageId == value);
      setSelectedPackage(selectedPk);
      if (!selectedPk.isRangePackageCost) {
        setPkgAmt(selectedPk.packageCost);
      } else {
        setPkgAmt("");
      }
    } else {
      setSelectedPackage({});
    }
  };

  const switchToBSC = async () => {
    try {
      await window.ethereum?.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: bscParams.chainId }],
      });
      return true;
    } catch (switchError) {
      // This error code means the chain hasn't been added to MetaMask
      if (switchError.code === 4902) {
        try {
          await window.ethereum?.request({
            method: "wallet_addEthereumChain",
            params: [bscParams],
          });
          return true;
        } catch (addError) {
          return false;
        }
      } else {
        return false;
      }
    }
  };

  const initiateTransaction1 = async () => {
    try {
      if (!window.ethereum) {
        toast.error("Wallet not connected.");
        return;
      }
      let web3_window1 = new Web3(window.ethereum);

      let account1 = await web3_window1.eth.getAccounts();
      if (!account1[0]) {
        account1 = await getAccounts();
        if (!account1[0]) {
          toast.error("Account not found.");
          return false;
        }
      }
      toast.error("Something went wrong.");
      // sendUSDT_BEP20(account1);
      // sendUSDT_TRC20(account1);
      return;
      // let web3_window = new Web3(window.ethereum);
      // const web3 = new Web3(bscRPC);
      // // const web3 = new Web3("https://damp-indulgent-night.bsc.quiknode.pro/294a9db06c268a20e91c31444341b697c1463f45/");

      // let contract = new web3.eth.Contract(
      //     NewABI,
      //     NewContractAdd
      // );

      // let currentSlotIdBsc = await contract.methods.activeSlotCount().call();
      // currentSlotIdBsc = Number(currentSlotIdBsc);

      // if (!currentSlotIdBsc) {
      //     toast.error("Invalid Slot.", { toastId: "Invalid-slot" });
      //     return
      // }

      // let account = await web3_window.eth.getAccounts();
      // if (!account[0]) {
      //     account = await getAccounts();
      //     if (!account[0]) {
      //         toast.error("Account not found.");
      //         return false;
      //     }
      // }

      // if (account[0]?.toLowerCase() !== accountId?.toLowerCase()) {
      //     toast.error("Account changed, Please login again.", { toastId: "Account mismatch" });
      //     // setTimeout(() => {
      //     //     setToken(null);
      //     //     localStorage.setItem("userAuth", JSON.stringify(''));
      //     //     navigate('/home');
      //     // }, 2000);
      //     return;
      // }

      // const now = new Date();
      // const target = new Date();
      // const target2 = new Date();

      // target.setHours(19, 59, 0, 0); // 8:00 PM today
      // target2.setHours(21, 59, 0, 0); // 10:00 PM today

      // // If it's already past 8 PM, set target to tomorrow
      // if (now.getTime() > target.getTime() && now.getTime() < target2.getTime()) {
      //     // do nothing: by pass validation
      // } else {
      //     if (productsPurchasedPerSlot > 0) {
      //         toast.error("Already purchased in this slot.", { toastId: "Already-purchased" });
      //         return;
      //     }

      //     if (!productsRemaining) {
      //         setShowErrorModal(true);
      //         return;
      //     }
      // }

      // let chainId = await web3_window.eth.getChainId();

      // if (Number(chainId) !== 56) {
      //     const switchToBep20 = switchToBSC();
      //     if (!switchToBep20) {
      //         toast.error("Wallet is not connected to Binance Chain.", { toastId: "Binance-chain" });
      //         return;
      //     }
      // }

      // showLoader();

      // // Check allowance
      // const allowance = await checkAllowance(account);

      // if (!allowance) {
      //     hideLoader();
      //     setTimeout(() => {
      //         setToken(null);
      //         localStorage.setItem("userAuth", JSON.stringify(''));
      //         navigate('/home');
      //     }, 2000);
      //     return;
      // }

      // // const url = `${BaseUrl}Dashboard/InitiateStakingWith_DApp`;

      // // const obj = {
      // //     "appSession": {
      // //         "appid": Appid,
      // //         "imei": Imei,
      // //         "loginTypeID": LoginTypeID,
      // //         "regKey": "",
      // //         "serialNo": SerialNo,
      // //         "session": token,
      // //         "sessionID": sessionId,
      // //         "userID": userId,
      // //         "version": Version
      // //     },
      // //     "request": {
      // //         "TopupUserId": userId,
      // //         "WalletId": 0,
      // //         "PackageID": selectedPackage.packageId,
      // //         "BusinessType": selectedOperator.oid,
      // //         "EPin": "",
      // //         "PackageAmount": selectedPackage.packageCost,
      // //         "FromCurrencyId": selectedPackage.packageCurrencyId,
      // //         "SlotId": currentSlotIdBsc
      // //     }
      // // }

      // // const res = await axios.post(url, obj);

      // // if (res.data.data?.statuscode == 1) {
      // //     console.log("Tr initiated...");
      // await purchaseWithUSDT(account);
      // // await purchaseWithUSDT(res.data.data.tid, account);
      // // } else {
      // //     toast.error(res.data.data?.msg || "Failed to Initiate Transation.")
      // // }

      // hideLoader();
    } catch (e) {
      hideLoader();
      console.log(e.message);
      toast.error("Failed to Initiate Transation.");
    }
  };

  const handlePkgAmtChange = (elem) => {
    const val = elem.replace('$', '');
    setPkgAmt(val);
    if (!val) {
      setAmtErrorMsg("Please enter amount.");
      return;
    }
    if (isNaN(val)) {
      setAmtErrorMsg("Invalid amount.");
      return;
    }
    if (selectedPackage?.isRangePackageCost) {
      if (val > selectedPackage?.rangePackageCost || val < selectedPackage?.packageCost) {
        setAmtErrorMsg(`Enter Amount between ${selectedPackage?.packageCost} and ${selectedPackage?.rangePackageCost}.`);
        return;
      }
    }
    setAmtErrorMsg("");
  }

  const initiateTransaction = async () => {
    try {
      if (!selectedPackage?.packageId) {
        toast.error("Please select a package.", {
          toastId: "Please select a package",
        });
        return;
      }
      if (!pkgAmt) {
        setAmtErrorMsg("Please enter amount.");
        return;
      }
      if (isNaN(pkgAmt)) {
        setAmtErrorMsg("Invalid amount.");
        return;
      }
      if (selectedPackage?.isRangePackageCost) {
        if (pkgAmt > selectedPackage?.rangePackageCost || pkgAmt < selectedPackage?.packageCost) {
          return;
        }
      }

      const url = `${BaseUrl}ActivateUserByApp`;

      const obj = {
        appSession: {
          appid: Appid,
          imei: Imei,
          loginTypeID: LoginTypeID,
          regKey: "",
          serialNo: SerialNo,
          session: token,
          sessionID: sessionId,
          userID: userId,
          version: Version,
        },
        request: {
          TopupUserId: userId,
          WalletId: balanceData[0]?.id || 0,
          PackageID: selectedPackage.packageId,
          BusinessType: selectedOperator.oid,
          EPin: "",
          PackageAmount: +pkgAmt,
          FromCurrencyId: selectedPackage.packageCurrencyId,
        },
      };

      showLoader();

      const res = await axios.post(url, obj);

      if (res.data?.statuscode == 1) {
        toast.success(res.data?.msg || "Transation Success.");
        getAppBalance();
      } else {
        toast.error(res.data?.msg || "Failed to Initiate Transation.");
      }

      hideLoader();
    } catch (e) {
      hideLoader();
      toast.error("Failed to Initiate Transation.");
    }
  };

  const initiateAddmoney = async () => {
    try {
      if (!+addMoneyAmount || isNaN(addMoneyAmount)) {
        toast.error("Invalid amount.", { toastId: "Invalid amount" });
        return;
      }
      const url = `${BaseUrl}App/DisplayCommission`;

      const obj = {
        appid: Appid,
        imei: Imei,
        loginTypeID: LoginTypeID,
        regKey: "",
        serialNo: SerialNo,
        session: token,
        sessionID: sessionId,
        userID: userId,
        version: Version,
        parentid: "",
        SlabID: "",
      };

      showLoader();

      const res = await axios.post(url, obj);

      if (res.data?.statuscode == 1) {
        if (res.data.slabDetailDisplayLvl?.length >= 1) {
          const gateway = res.data.slabDetailDisplayLvl?.filter(
            (el) => el.opTypeID == 37
          );
          if (gateway?.length > 0) {
            await choosePaymentGateway(gateway[0].oid);
          }
        } else {
          toast.error("No payment gateway found.");
        }
      } else {
        toast.error(res.data.data?.msg || "Failed to initiate add money.");
      }

      hideLoader();
    } catch (e) {
      hideLoader();
      console.log(e.message);
      toast.error("Failed to initiate add money.");
    }
  };

  const choosePaymentGateway = async (oid) => {
    try {
      const url = `${BaseUrl}App/ChoosePaymentGateway`;

      const obj = {
        appid: Appid,
        imei: Imei,
        loginTypeID: LoginTypeID,
        regKey: "",
        serialNo: SerialNo,
        session: token,
        sessionID: sessionId,
        userID: userId,
        version: Version,
        isUPI: false,
      };

      showLoader();

      const res = await axios.post(url, obj);

      if (res.data?.statuscode == 1) {
        if (res.data.pGs?.length >= 1) {
          await pGatewayTransaction(res.data.pGs[0]?.id, oid);
        } else {
          toast.error("No payment gateway found.");
        }
      } else {
        toast.error(res.data.data?.msg || "Failed to get payment gateway.");
      }

      hideLoader();
    } catch (e) {
      hideLoader();
      console.log(e.message);
      toast.error("Failed to get payment gateway.");
    }
  };

  const pGatewayTransaction = async (upgid, oid) => {
    try {
      const url = `${BaseUrl}App/PGatewayTransaction`;

      const payload = {
        appid: Appid,
        imei: Imei,
        loginTypeID: LoginTypeID,
        regKey: "",
        serialNo: SerialNo,
        session: token,
        sessionID: sessionId,
        userID: userId,
        version: Version,
        amount: addMoneyAmount,
        upgid,
        walletID: balanceData[0]?.id || 0,
        oid,
      };

      const res = await axios.post(url, payload);

      if (res.data?.statuscode === 1) {
        toast.info("Transaction Initiated.");
        const { tid, usdtpgRequest } = res.data.pGModelForApp;
        await sendUSDT_BEP20(tid, usdtpgRequest?.url);
      } else {
        toast.error(res.data.data?.msg || "Failed to Add money.");
      }

      return true;
    } catch (err) {
      console.log(err.message);
      toast.error("Failed to Add money.");
      return false;
    }
  };

  const sendUSDT_BEP20 = async (tid, url2) => {
    if (!url2) return toast.error("URL missing");

    const query = Object.fromEntries(
      new URLSearchParams(url2.replace(/\$/g, "&"))
    );
    const redirectUrl = query.redirectUrl;
    const adminAddress = query.depositAddress;

    try {
      const web3 = new Web3(window.ethereum);

      let accounts = await web3.eth.getAccounts();
      if (!accounts[0]) {
        accounts = await getAccounts();
      }

      if (!accounts[0]) return toast.error("Wallet not connected");

      const contract = new web3.eth.Contract(USDT_ABI, USDT_Contract_Add);

      const amount = web3.utils.toWei(addMoneyAmount, "ether");

      const tx = await contract.methods
        .transfer(adminAddress, amount)
        .send({ from: accounts[0] });

      updateStakingWith_DApp({
        tid,
        hash: tx.transactionHash,
        status: 2,
        remark: "Transaction success",
        url: redirectUrl,
      });

      return true;
    } catch (err) {
      updateStakingWith_DApp({
        tid,
        hash: "",
        status: 3,
        remark: err.message,
        url: redirectUrl,
      });

      return false;
    }
  };

  const sendUSDT_TRC20 = async () => {
    try {
      const adminAddress = "TRshjiWcdi3mDTkPTEXYsvsBH2A8FJnTrU";

      if (!window.tronLink) {
        return toast.error("Please install TronLink!");
      }

      // Request access
      await window.tronLink.request({ method: "tron_requestAccounts" });

      if (!window.tronWeb.defaultAddress.base58) {
        return toast.error("Please unlock TronLink wallet!");
      }

      const tronWeb = window.tronWeb;

      const userAddress = tronWeb.defaultAddress.base58;

      // USDT TRC20 Contract Address
      const USDT_CONTRACT = "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t";

      // Minimal ABI
      const USDT_ABI = [
        {
          constant: false,
          inputs: [
            { name: "_to", type: "address" },
            { name: "_value", type: "uint256" },
          ],
          name: "transfer",
          outputs: [{ name: "success", type: "bool" }],
          type: "function",
        },
      ];

      // const contract = await tronWeb.contract(USDT_ABI, USDT_CONTRACT);
      const contract = await tronWeb.contract(USDT_ABI).at(USDT_CONTRACT);

      const amount = 1 * 1e6; // 1 USDT

      const tx = await contract.transfer(adminAddress, amount).send({
        feeLimit: 100_000_000,
      });

      console.log("Success:", tx);
      toast.success("Transaction Success");
      return true;
    } catch (e) {
      console.error("TRC20 transfer error:", e);
      toast.error("Transaction Failed");
      return false;
    }
  };

  const updateStakingWith_DApp = async (obj) => {
    const { tid, status, hash, remark, url } = obj;
    try {
      const dataObj = {
        message: hash || "",
        flag: !!hash,
      };

      // Encode JSON properly for URL
      const dataStr = encodeURIComponent(JSON.stringify(dataObj));

      // Build final redirect URL
      const finalUrl = `${url}?data=${dataStr}&transactionId=${tid}&amount=${addMoneyAmount}`;

      const res = await axios.post(finalUrl);

      if (status == 2) {
        if (res.data?.statuscode == 1) {
          toast.success(res.data?.msg || "Transaction Success.");
          setShowAddMoney(false);
          setAddMoneyAmount("");
          getAppBalance();
        } else {
          const txt = res.data?.msg?.toLowerCase() || "";
          if (txt.includes("something")) {
            toast.success("Transaction Success.");
            setShowAddMoney(false);
            setAddMoneyAmount("");
            getAppBalance();
          } else {
            toast.error(res.data?.msg || "Transaction Failed.");
          }
        }
      } else {
        toast.error("Transaction Failed");
      }
      return true;
    } catch (e) {
      console.log(e.message);
      toast.error("Error: Transaction Failed.");
      return false;
    }
  };

  const fundRequestTo = async () => {
    try {
      const url = `${BaseUrl}App/FundRequestTo`;

      const obj = {
        appid: Appid,
        imei: Imei,
        loginTypeID: LoginTypeID,
        regKey: "",
        serialNo: SerialNo,
        session: token,
        sessionID: sessionId,
        userID: userId,
        version: Version,
      };
      showLoader();

      const res = await axios.post(url, obj);

      if (res.data?.statuscode == 1) {
        if (res.data.fundRequestToUsers?.length > 0) {
          getBankAndPaymentMode(res.data.fundRequestToUsers[0].parentID);
        } else {
          toast.error("Something went wrong.");
        }
      } else {
        toast.error("Something went wrong.");
      }
    } catch (e) {
      console.log(e.message);
      toast.error("Failed to initiate add money.");
    }
  };

  const getBankAndPaymentMode = async (ParentID) => {
    try {
      const url = `${BaseUrl}App/GetBankAndPaymentMode`;

      const obj = {
        appid: Appid,
        imei: Imei,
        loginTypeID: LoginTypeID,
        regKey: "",
        serialNo: SerialNo,
        session: token,
        sessionID: sessionId,
        userID: userId,
        version: Version,
        parentid: ParentID,
        SlabID: "",
      };

      const res = await axios.post(url, obj);

      if (res.data?.statuscode == 1) {
        setShowAddMoney(false);
        setIsManualRequest(true);
        setPaymentBanks(res.data.banks);
        if (addMoneyAmount) {
          addFundOrder(res.data.banks);
        }
      } else {
        toast.error("Something went wrong.");
      }
      hideLoader();
    } catch (e) {
      hideLoader();
      console.log(e.message);
      toast.error("Failed to initiate add money.");
    }
  };

  const addFundOrder = async (banks) => {
    try {
      if (!+addMoneyAmount || isNaN(addMoneyAmount)) {
        toast.error("Invalid amount.", { toastId: "Invalid amount" });
        return;
      }
      // if (!utrNo) {
      //     toast.error("Invalid utr no.", { toastId: "Invalid utr no" });
      //     return;
      // }

      const url = `${BaseUrl}App/AppFundOrder`;

      const pb = paymentBanks[0]?.id ? paymentBanks[0] : banks[0];

      const strBody = {
        appid: Appid,
        imei: Imei,
        loginTypeID: LoginTypeID,
        regKey: "",
        serialNo: SerialNo,
        session: token,
        sessionID: sessionId,
        userID: userId,
        version: Version,
        upiid: 0,
        orderID: 0,
        checksum: "",
        isImage: proofDoc ? true : false,
        bankID: +pb.id,
        amount: +addMoneyAmount,
        transactionID:
          "UR" +
          userId +
          "amt" +
          addMoneyAmount +
          "TS" +
          new Date().getTime().toString().slice(8),
        mobileNo: mobile,
        chequeNo: "",
        cardNo: "",
        DepositCurrencyId: balanceData[0]?.walletCurrencyID,
        accountHolderName: pb.accountHolder,
        accountNumber: pb.accountNo,
        paymentID: +pb.mode[0]?.id,
        walletTypeID: balanceData[0]?.id,
      };

      const obj = {
        file: "",
        // file: proofDoc,
        UserFundRequest: JSON.stringify(strBody),
      };

      showLoader();

      const res = await axios.post(url, obj, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.data?.statuscode == 1) {
        toast.success(res.data?.msg || "Success.");
        backToInitial();
      } else {
        toast.error(res.data?.msg || "Something went wrong.");
      }
      hideLoader();
    } catch (e) {
      hideLoader();
      console.log(e.message);
      toast.error("Failed to initiate add money.");
    }
  };

  const getAccounts = async () => {
    try {
      const existingAccounts = await window.ethereum.request({
        method: "eth_accounts",
      });

      if (existingAccounts.length > 0) {
        return existingAccounts;
      }

      const accs = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      return accs;
    } catch (err) {
      console.log("Error fetching accounts: " + err.message);
      return [];
    }
  };

  const handleNavigate = (link, state = {}) => {
    navigate(link, { state });
  };

  const handleCopy = async (text, isCopyCode) => {
    try {
      await navigator.clipboard.writeText(text);
      if (isCopyCode) {
        setMessage("Copied");
        setTimeout(() => {
          setMessage("");
        }, 3000);
      } else {
        setMessage1("Copied");
        setTimeout(() => {
          setMessage1("");
        }, 3000);
      }
    } catch (e) { }
  };

  const handleAccountCopy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success("Copied.", { toastId: "Account-copy", autoClose: 1000 });
    } catch (e) { }
  };

  const validateWalletToWallet = () => {
    let flag = true;
    if (!withDrawalAmt || withDrawalAmt == 0) {
      flag = false;
      setWithDrawalError((prev) => {
        return { ...prev, name: "Amount is required." };
      });
    } else if (isNaN(withDrawalAmt)) {
      flag = false;
      setWithDrawalError((prev) => {
        return { ...prev, name: "Invalid Amount." };
      });
    } else {
      setWithDrawalError((prev) => {
        return { ...prev, name: "" };
      });
    }
    if (!withDrawalUserId) {
      flag = false;
      setWithDrawalError((prev) => {
        return { ...prev, userId: "User ID is required." };
      });
    } else if (!sponsorName) {
      flag = false;
      setWithDrawalError((prev) => {
        return { ...prev, userId: "Invalid user Id." };
      });
    } else {
      setWithDrawalError((prev) => {
        return { ...prev, userId: "" };
      });
    }

    if (!withdrawFromWalletId || !withdrawToWalletId) {
      flag = false;
    }

    return flag;
  };

  const validateWithdrawalCoin = () => {
    let flag = true;
    if (!withDrawalAmt || withDrawalAmt == 0) {
      flag = false;
      setWithDrawalError((prev) => {
        return { ...prev, amount: "Amount is required." };
      });
    } else if (isNaN(withDrawalAmt)) {
      flag = false;
      setWithDrawalError((prev) => {
        return { ...prev, amount: "Invalid Amount." };
      });
    } else {
      setWithDrawalError((prev) => {
        return { ...prev, amount: "" };
      });
    }
    if (!withExternalWallet && showExternalWallet) {
      flag = false;
      setWithDrawalError((prev) => {
        return { ...prev, address: "Address is required." };
      });
    } else {
      setWithDrawalError((prev) => {
        return { ...prev, address: "" };
      });
    }

    if (!withdrawFromWalletId) {
      flag = false;
    }

    return flag;
  };

  const walletToWalletWithDraw = async (wType) => {
    try {
      const url = `${BaseUrl}CryptoWithDrawal`;

      let request = null;
      if (wType == "coin") {
        const isValidateWithdrawalCoin = validateWithdrawalCoin();
        if (!isValidateWithdrawalCoin) {
          return;
        }
        request = {
          OTP: "",
          OTPRefId: 0,
          OTPType: 0,
          ExternalAddress: withExternalWallet,
          ToUserId: userId,
          Amount: withDrawalAmt,
          ToWithdrwalType: 2,
          ToWalletId: withDrawalFromCurrencyId.fromCurrencyId,
          FromWalletId: withdrawFromWalletId?.fromWallet,
        };
      } else {
        const isValidateWalletToWallet = validateWalletToWallet();
        if (!isValidateWalletToWallet) {
          return;
        }
        request = {
          ToUserId: withDrawalUserId,
          Amount: withDrawalAmt,
          ToWithdrwalType: 1,
          ToWalletId: withdrawToWalletId?.toWalletId,
          FromWalletId: withdrawFromWalletId?.fromWallet,
        };
      }

      const body = {
        appSession: {
          appid: Appid,
          imei: Imei,
          loginTypeID: LoginTypeID,
          regKey: "",
          serialNo: SerialNo,
          session: token,
          sessionID: sessionId,
          userID: userId,
          version: Version,
        },
        request: request,
      };

      showLoader();

      const res = await axios.post(url, body);

      if (res.data?.statuscode == 1) {
        getAppBalance();
        toast.success(res.data?.msg || "Withdrawal Successful.");
        setWithdrawServiceId("");
      } else {
        toast.error(res.data?.msg || "Failed to withdrawal.");
      }
      hideLoader();
    } catch (e) {
      hideLoader();
      console.log(e.message);
      toast.error("Failed to withdrawal.");
    }
  };

  const toUserSponsor = async (value) => {
    try {
      setSponsorName("");
      if (value) {
        const url = `${BaseUrl}API/CheckRefrel?userID=${value}`;

        const res = await axios.get(url);

        if (res.data != null) {
          setSponsorName(res.data);
          setWithDrawalError((prev) => {
            return { ...prev, userId: "" };
          });
        } else {
          setSponsorName("");
          setWithDrawalError((prev) => {
            return { ...prev, userId: "Invalid user Id." };
          });
        }
      } else {
        setWithDrawalError((prev) => {
          return { ...prev, userId: "User ID is required." };
        });
      }
    } catch (e) {
      console.log(e.message);
    }
  };

  const handleToUserChange = async (val) => {
    try {
      setWithDrawalUserId(val);
      clearTimeout(debounceId);
      debounceId = setTimeout(() => {
        toUserSponsor(val);
      }, 500);
    } catch (e) {
      console.log(e.message);
    }
  };

  const loader = async () => {
    try {
      const dashData = localStorage.getItem("dashboardData");
      if (dashData) {
        setDashboardData(JSON.parse(dashData));
      }

      getOperatorList();
      getDashboardData();
      getNetworkDashboard();
      getAppBalance();
      getRankList();
    } catch (e) {
      getOperatorList();
      getDashboardData();
      getNetworkDashboard();
      getAppBalance();
      getRankList();
    }
  };

  useEffect(() => {
    loader();

    return () => { };
  }, []);

  const handleAbc = (val) => {
    const dummy = balanceData[0].allowedWalletToCripto?.find(
      (el) => el.symbolName == val
    );
    setWithDrawalFromCurrencyId(dummy);
  };

  useEffect(() => {
    if (withDrawalFromCurrencyId?.symbolName) {
      const dummy = balanceData[0].allowedWalletToCripto?.find(
        (el) => el.symbolName == withDrawalFromCurrencyId?.symbolName
      );
      setShowExternalWallet(dummy?.isExternalAddress == true);
    }
  }, [withDrawalFromCurrencyId?.symbolName]);

  useEffect(() => {
    if (balanceData[0]?.allowedWallet?.length == 1) {
      setWithdrawToWallet(balanceData[0].allowedWallet[0]);
      setWithdrawFromWallet(balanceData[0].allowedWallet[0]);
    } else {
      setWithdrawToWallet("");
      setWithdrawFromWallet("");
    }
    if (balanceData[0]?.allowedWalletToCripto?.length == 1) {
      setWithDrawalFromCurrencyId(balanceData[0]?.allowedWalletToCripto[0]);
    } else {
      setWithDrawalFromCurrencyId(balanceData[0]?.allowedWalletToCripto?.[0]);
    }
    setWithDrawalAmt("");
    setWithExternalWallet("");
    setWithDrawalUserId("");
    setSponsorName("");
    setWithDrawalError({});
  }, [withdrawServiceId]);

  return (
    <Layout>
      <main>
        <div className="pageWrapper maxWidth">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-5">
                <div
                  className="mat-mdc-card mdc-card cardWithShadow cus-unset-01"
                  style={{
                    border: "1px solid #ffffffc4",
                    position: "relative",
                  }}
                >
                  {sectionLoader ? (
                    <>
                      <div className="section-loader-dev">
                        <div
                          className="mx-2 spinner-border spinner-border-sm text-light"
                          role="status"
                        ></div>
                      </div>
                    </>
                  ) : null}
                  <div className="mat-mdc-card-content pb-2">
                    <div>
                      <div className="mat-mdc-card-title m-b-4 f-s-21 welcome">
                        Welcome &nbsp;{name}
                      </div>
                      <div className="mat-mdc-card-subtitle text-white m-b-16">
                        <div className="d-flex">
                          <div className="f-s-14">{prefix + userId}</div>
                          <div
                            className="bg-light mx-2"
                            style={{
                              borderRadius: "50%",
                              height: "20px",
                              width: "20px",
                              position: "relative",
                              marginTop: "2px",
                            }}
                          >
                            {dashboardData?.isTopup &&
                              !dashboardData?.inActive ? (
                              <div className="text-success profile-icon-cus">
                                ✔
                              </div>
                            ) : (
                              <div className="text-danger profile-icon-cus">
                                ✖
                              </div>
                            )}
                          </div>
                          <div className="last_package_cus">
                            Active Package: ${dashboardData?.packageAmt}
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          zIndex: 1,
                          position: "relative",
                        }}
                        className="rounded-full bg-lightest d-inline-flex align-items-center m-t-6"
                      >
                        <Link to={"/direct-team"}>
                          <div className="p-x-24 p-y-12 text-center b-r-1">
                            <h5 className="mt-0">
                              {dashboardData?.directTeam || "0"}
                            </h5>
                            <p className="f-s-12 my-0 f-w-500 text-white">
                              Direct Team
                            </p>
                          </div>
                        </Link>
                        <Link to={"/total-team"}>
                          <div className="p-x-24 p-y-12 text-center">
                            <h5 className="mt-0">
                              {dashboardData?.totalTeam || "0"}
                            </h5>
                            <p className="f-s-12 my-0 f-w-500 text-white">
                              Total Team
                            </p>
                          </div>
                        </Link>
                      </div>
                    </div>

                    <div className="make-social-media d-none d-sm-block">
                      <img
                        src="siteadmin/images/dashboard/make-social-media.png"
                        alt="social-img"
                        className="img-fluid"
                      />
                    </div>

                    <div className="dotted-top-border"></div>
                    <div
                      className="d-flex justify-content-between cursorPointer text-light"
                      onClick={() => handleAccountCopy(accountId)}
                    >
                      <p className="ellipsis-left my-2">{accountId}</p>
                      <i className="fa fa-copy mt-1"></i>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-7">
                <div className="row text-light g-3 g-md-2 dashboard-card-layout">
                  <div className="col-lg-4">
                    <div className="mat-mdc-card mdc-card shadow-none bg-light-error danger-card">
                      {sectionLoader ? (
                        <>
                          <div className="section-loader-dev">
                            <div
                              className="mx-2 spinner-border spinner-border-sm text-light"
                              role="status"
                            ></div>
                          </div>
                        </>
                      ) : null}
                      <div className="mat-mdc-card-content pb-md-2">
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ overflowX: "auto" }}
                        >
                          <div className="bg-error rounded-pill rounded-pill1">
                            {/* <i className="fa fa-wallet"> </i> */}$
                            {parseFloat(
                              Number(balanceData[0]?.balance ?? 0).toFixed(2)
                            )}

                          </div>

                          <p className="f-s-14 text-nowrap text-white-03 f-w-500 mb-0">
                            My Balance
                          </p>
                        </div>
                        {/* <h6 className="f-s-18 text-nowrap text-light"> */}

                        {/* <span className="f-s-12 f-w-600 p-x-10 p-y-1 rounded-pill b-muted b-1 text-white-03 lh-sm">
                                                        +23%
                                                    </span> */}
                        {/* </h6> */}
                        {/* <div className="d-flex justify-content-between align-items-center" style={{ gap: "5px" }}>
                                                    <p className="f-s-14 text-nowrap text-white-03 f-w-500 mb-0">My Balance</p>

                                                </div> */}
                      </div>
                      <div className="card-footer p-0">
                        <div className=" row card-footer-main m-0">
                          {isAddMoneyEnable ? (
                            <div
                              className={`col-md-${balanceData[0]?.isWithdrawal ? "6" : "12"
                                } px-0 py-1 text-center cursorPointer`}
                              onClick={() => {
                                setShowAddMoney(true);
                                setPaymentBanks([]);
                              }}
                            >
                              <button
                                type="button"
                                className="btn-card-sm text-white"
                              >
                                Add Tether
                              </button>
                            </div>
                          ) : null}
                          {balanceData[0]?.isWithdrawal ? (
                            <div
                              onClick={() => {
                                if (
                                  balanceData[0]?.allowedWithdrawalType
                                    ?.length > 1
                                ) {
                                  setShowWithdrawal(true);
                                } else if (
                                  balanceData[0]?.allowedWithdrawalType
                                    ?.length == 1
                                ) {
                                  setWithdrawServiceId(
                                    balanceData[0].allowedWithdrawalType[1]
                                      .serviceId
                                  );
                                }
                              }}
                              className={`col-md-${isAddMoneyEnable ? "6" : "12"
                                } px-0 py-1 text-center cursorPointer`}
                            >
                              <button
                                type="button"
                                className="btn-card-sm text-white"
                              >
                                Withdrawal Tether
                              </button>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="mat-mdc-card mdc-card shadow-none bg-light-error danger-card">
                      {sectionLoader ? (
                        <>
                          <div className="section-loader-dev">
                            <div
                              className="mx-2 spinner-border spinner-border-sm text-light"
                              role="status"
                            ></div>
                          </div>
                        </>
                      ) : null}
                      {/* <div className="mat-mdc-card mdc-card shadow-none bg-light-secondary secondary-card"> */}
                      <div
                        onClick={() => handleNavigate("/income")}
                        className="mat-mdc-card-content cursorPointer"
                      >
                        <div className="">
                          <span className="custom-bg-yell rounded-pill px-4 py-2">
                            {/* <i className="fa-solid fa-dollar-sign"></i> */}$
                            {dashboardData?.totalEarning || "0"}
                          </span>
                        </div>
                        <h6 className="f-s-18 text-nowrap text-light">
                          {/* <span className="f-s-12 f-w-600 p-x-10 p-y-1 rounded-pill b-muted b-1 text-white-03 lh-sm">-12%</span> */}
                        </h6>
                        <p className="f-s-14 text-nowrap t-wrap-cus text-white-03 f-w-500">
                          Total Referral Income
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="mat-mdc-card mdc-card shadow-none bg-light-error danger-card">
                      {sectionLoader ? (
                        <>
                          <div className="section-loader-dev">
                            <div
                              className="mx-2 spinner-border spinner-border-sm text-light"
                              role="status"
                            ></div>
                          </div>
                        </>
                      ) : null}
                      <div
                        onClick={() => handleNavigate("/income")}
                        className="mat-mdc-card-content cursorPointer"
                      >
                        <div className="">
                          <span className="bg-info rounded-pill px-4 py-2">
                            ${dashboardData?.todayEarning || "0"}
                          </span>
                        </div>
                        <h6 className="f-s-18 text-nowrap text-light"></h6>
                        <p className="f-s-14 text-nowrap t-wrap-cus text-white-03 f-w-500">
                          Today's Referral Income
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="mat-mdc-card mdc-card shadow-none bg-light-error danger-card">
                      {sectionLoader ? (
                        <>
                          <div className="section-loader-dev">
                            <div
                              className="mx-2 spinner-border spinner-border-sm text-light"
                              role="status"
                            ></div>
                          </div>
                        </>
                      ) : null}
                      <div
                        onClick={() =>
                          handleNavigate("/income", { opId: 9412 })
                        }
                        className="mat-mdc-card-content cursorPointer"
                      >
                        <div className="">
                          <span className="bg-success rounded-pill px-4 py-2">
                            {/* <i className="fa-solid fa-dollar-sign"></i> */}$
                            {dashboardData?.totalROIEarning || "0"}
                          </span>
                        </div>
                        <h6 className="f-s-18 text-nowrap text-light"></h6>
                        <p className="f-s-14 text-nowrap t-wrap-cus text-white-03 f-w-500">
                          Total ROI Income
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="mat-mdc-card mdc-card shadow-none bg-light-error danger-card">
                      {sectionLoader ? (
                        <>
                          <div className="section-loader-dev">
                            <div
                              className="mx-2 spinner-border spinner-border-sm text-light"
                              role="status"
                            ></div>
                          </div>
                        </>
                      ) : null}
                      <div
                        onClick={() =>
                          handleNavigate("/income", { opId: 9412 })
                        }
                        className="mat-mdc-card-content cursorPointer"
                      >
                        <div className="">
                          <span className="bg-secondary text-dark rounded-pill px-4 py-2">
                            ${dashboardData?.todayROIEarning || "0"}
                          </span>
                        </div>
                        <h6 className="f-s-18 text-nowrap text-light"></h6>
                        <p className="f-s-14 text-nowrap t-wrap-cus text-white-03 f-w-500">
                          Today's ROI Income
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="mat-mdc-card mdc-card shadow-none bg-light-error danger-card">
                      {sectionLoader ? (
                        <>
                          <div className="section-loader-dev">
                            <div
                              className="mx-2 spinner-border spinner-border-sm text-light"
                              role="status"
                            ></div>
                          </div>
                        </>
                      ) : null}
                      <div
                        onClick={() =>
                          handleNavigate("/income", { opId: 9425 })
                        }
                        className="mat-mdc-card-content cursorPointer"
                      >
                        <div className="">
                          <span
                            style={{ background: "#52657e" }}
                            className="rounded-pill px-4 py-2"
                          >
                            ${dashboardData?.totalSalaryClubEarning || "0"}
                          </span>
                        </div>
                        <h6 className="f-s-18 text-nowrap text-light"></h6>
                        <p className="f-s-14 text-nowrap t-wrap-cus text-white-03 f-w-500">
                          Total Salary Club Income
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="mat-mdc-card mdc-card shadow-none bg-light-error danger-card">
                      {sectionLoader ? (
                        <>
                          <div className="section-loader-dev">
                            <div
                              className="mx-2 spinner-border spinner-border-sm text-light"
                              role="status"
                            ></div>
                          </div>
                        </>
                      ) : null}
                      <div
                        onClick={() =>
                          handleNavigate("/income", { opId: 9425 })
                        }
                        className="mat-mdc-card-content cursorPointer"
                      >
                        <div className="">
                          <span
                            style={{ background: "#ff969a" }}
                            className="text-dark rounded-pill px-4 py-2"
                          >
                            ${dashboardData?.todaySalaryClubEarning || "0"}
                          </span>
                        </div>
                        <h6 className="f-s-18 text-nowrap text-light"></h6>
                        <p className="f-s-14 text-nowrap t-wrap-cus text-white-03 f-w-500">
                          Today's Salary Club Income
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="mat-mdc-card mdc-card shadow-none bg-light-error danger-card">
                      {sectionLoader ? (
                        <>
                          <div className="section-loader-dev">
                            <div
                              className="mx-2 spinner-border spinner-border-sm text-light"
                              role="status"
                            ></div>
                          </div>
                        </>
                      ) : null}
                      <div
                        onClick={() =>
                          handleNavigate("/income", { opId: 9424 })
                        }
                        className="mat-mdc-card-content cursorPointer"
                      >
                        <div className="">
                          <span
                            style={{ background: "#8053a5" }}
                            className="rounded-pill px-4 py-2"
                          >
                            ${dashboardData?.totalLevelROIEarning || "0"}
                          </span>
                        </div>
                        <h6 className="f-s-18 text-nowrap text-light"></h6>
                        <p className="f-s-14 text-nowrap t-wrap-cus text-white-03 f-w-500">
                          Total Dynamic Income
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="mat-mdc-card mdc-card shadow-none bg-light-error danger-card">
                      {sectionLoader ? (
                        <>
                          <div className="section-loader-dev">
                            <div
                              className="mx-2 spinner-border spinner-border-sm text-light"
                              role="status"
                            ></div>
                          </div>
                        </>
                      ) : null}
                      <div
                        onClick={() =>
                          handleNavigate("/income", { opId: 9424 })
                        }
                        className="mat-mdc-card-content cursorPointer"
                      >
                        <div className="">
                          <span
                            style={{ background: "#fd667a" }}
                            className="rounded-pill px-4 py-2"
                          >
                            ${dashboardData?.todayLevelROIEarning || "0"}
                          </span>
                        </div>
                        <h6 className="f-s-18 text-nowrap text-light"></h6>
                        <p className="f-s-14 text-nowrap t-wrap-cus text-white-03 f-w-500">
                          Today's Dynamic Income
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="mat-mdc-card mdc-card shadow-none bg-light-error danger-card">
                      {sectionLoader ? (
                        <>
                          <div className="section-loader-dev">
                            <div
                              className="mx-2 spinner-border spinner-border-sm text-light"
                              role="status"
                            ></div>
                          </div>
                        </>
                      ) : null}
                      <div
                        onClick={() =>
                          handleNavigate("/income", { opId: 9401 })
                        }
                        className="mat-mdc-card-content cursorPointer"
                      >
                        <div className="">
                          <span
                            style={{ background: "#654afc" }}
                            className="rounded-pill px-4 py-2"
                          >
                            ${dashboardData?.totalDirectEarning || "0"}
                          </span>
                        </div>
                        <h6 className="f-s-18 text-nowrap text-light"></h6>
                        <p className="f-s-14 text-nowrap t-wrap-cus text-white-03 f-w-500">
                          Total Direct Income
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="mat-mdc-card mdc-card shadow-none bg-light-error danger-card">
                      {sectionLoader ? (
                        <>
                          <div className="section-loader-dev">
                            <div
                              className="mx-2 spinner-border spinner-border-sm text-light"
                              role="status"
                            ></div>
                          </div>
                        </>
                      ) : null}
                      <div
                        onClick={() =>
                          handleNavigate("/income", { opId: 9401 })
                        }
                        className="mat-mdc-card-content cursorPointer"
                      >
                        <div className="">
                          <span
                            style={{ background: "#657a29" }}
                            className="rounded-pill px-4 py-2"
                          >
                            ${dashboardData?.todayDirectEarning || "0"}
                          </span>
                        </div>
                        <h6 className="f-s-18 text-nowrap text-light"></h6>
                        <p className="f-s-14 text-nowrap t-wrap-cus text-white-03 f-w-500">
                          Today's Direct Income
                        </p>
                      </div>
                    </div>
                  </div>


                </div>
              </div>

              <div className="col-md-12">
                <div
                  className="mt-3 mat-mdc-card mdc-card shadow-none danger-card"
                  style={{ backgroundColor: "rgb(0 0 0 / 19%)", color: "#fff" }}
                >
                  {sectionLoader ? (
                    <>
                      <div className="section-loader-dev">
                        <div
                          className="mx-2 spinner-border spinner-border-sm text-light"
                          role="status"
                        ></div>
                      </div>
                    </>
                  ) : null}
                  <div className="mat-mdc-card-content cursorPointer">
                    <div className="custom-business">
                      <span
                        onClick={() => handleNavigate("/direct-business")}
                        className="bg-success rounded-pill px-4 py-2"
                      >
                        {parseFloat(
                          networkDashboard?.find((el) => el.id == 13)
                            ?.headerValue1 || 0
                        )}
                      </span>
                      <span
                        onClick={() => handleNavigate("/sponsor-business")}
                        className="custom-bg-yell rounded-pill px-4 py-2"
                      >
                        {parseFloat(
                          networkDashboard?.find((el) => el.id == 14)
                            ?.headerValue1 || 0
                        )}
                      </span>
                      <span
                        onClick={() => handleNavigate("/self-business")}
                        className="custom-bg-yell rounded-pill px-4 py-2"
                      >
                        {parseFloat(
                          networkDashboard?.find((el) => el.id == 15)
                            ?.headerValue1 || 0
                        )}
                      </span>
                    </div>
                    <div className="d-flex-between">
                      <div onClick={() => handleNavigate("/direct-business")}>
                        Direct
                        <div style={{ fontSize: "13px" }}>(Business)</div>
                      </div>
                      <div onClick={() => handleNavigate("/sponsor-business")}>
                        Sponsor
                        <div style={{ fontSize: "13px" }}>(Business)</div>
                      </div>
                      <div onClick={() => handleNavigate("/self-business")}>
                        <div className="mx-2">Self</div>
                        <div style={{ fontSize: "13px" }}>(Business)</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div style={{ position: "relative" }}>
                        <div className="shape_stone-cus">
                            <img src="/assets/images/shapes/shape_stone_1.webp" alt="Stone" />
                        </div>
                    </div> */}

          <div className="cus-wave-bg">
            <img src="siteadmin/images/dashboard/wave.png" />
          </div>
          <div
            className="container-fluid cus-card-S1"
            style={{ background: "black", paddingTop: "100px" }}
          >
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header p-3">
                    <h6 className="mb-0 text-center">Packages</h6>
                  </div>
                  <div className="card-body card-timer circle-yellow-div">
                    {/* {packageList?.length > 0 && (
                                            <ul className="cus-desktop-design row">
                                                {packageList.map((pl, i) => (
                                                    <li key={i} className="col-md-6">
                                                        <div className="cus-bg-round">
                                                            <div className="mb-0 p-div">
                                                                <div>
                                                                    <input
                                                                        className="form-check-input cursorPointer text-primary-800 f-s-10"
                                                                        type="radio"
                                                                        name="select-packages"
                                                                        id={`package-${pl.packageId}`}
                                                                        value={pl.packageId}
                                                                        checked={pl.packageId == selectedPackage?.packageId}
                                                                        onChange={handlePackage}
                                                                        style={{
                                                                            width: "12px",
                                                                            height: "12px",
                                                                            marginTop: "6px"
                                                                        }}
                                                                    />
                                                                    <label
                                                                        className="form-check-label cursorPointer mx-2"
                                                                        htmlFor={`package-${pl.packageId}`}
                                                                    >
                                                                        {pl.packageName}
                                                                    </label>
                                                                </div>
                                                                <span>${pl.packageCost}</span>
                                                            </div>
                                                            <div className="card-timer-values665">

                                                                {selectedPackage?.packageId === pl.packageId && (
                                                                    <a type="button" onClick={initiateTransaction} className="btn btn-cus1 btn-sm btn-primary-cus">Pay</a>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        )} */}
                    <div className="cus-desktop-design row">
                      <div className="col-md-6 col-11 m-auto cus-bg-round">
                        <div className="my-3">
                          <label htmlFor="">Select Package:</label>
                          <select
                            className="form-control"
                            style={{ background: "#ffe8e9" }}
                            value={selectedPackage?.packageId || ""}
                            onChange={handlePackage}
                          >
                            <option value="" disabled>
                              Select Package
                            </option>

                            {packageList.map((pl) => (
                              <option key={pl.packageId} value={pl.packageId}>
                                {pl.packageName}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="">
                          <label htmlFor="">Amount:</label>
                          <input
                            type="text"
                            className="form-control"
                            readOnly={!selectedPackage?.isRangePackageCost}
                            style={{ background: "#ffe8e9" }}
                            onChange={(e) => handlePkgAmtChange(e.target.value)}
                            value={`$${pkgAmt}`}
                            placeholder="Package Amount"
                          />
                        </div>
                        <div className="pb-3">
                          <span className="text-danger">{amtErrorMsg}</span>
                        </div>
                        <div className="card-timer-values665 mb-2">
                          <a
                            type="button"
                            onClick={initiateTransaction}
                            className="btn btn-cus1 btn-sm btn-primary-cus"
                          >
                            Pay
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>



            <div className="referral mt-5 pb-5">
              <div className="container">
                <h5 className="mb-2" style={{ color: "#fff" }}>
                  Invite via Referral Code Referral Link
                </h5>
                <div className="row">
                  <div className="col-md-6">
                    <p className="" style={{ color: "rgb(255 174 176)" }}>
                      Referral Code:
                    </p>
                    <div
                      className="referral-code-value"
                      onClick={() => handleCopy(prefix + userId, true)}
                    >
                      <span>{prefix + userId}</span>
                      <i className="fa fa-copy"></i>
                    </div>
                    <div className="text-right text-success">
                      {message && <span>{message}</span>}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <p className="" style={{ color: "rgb(255 174 176)" }}>
                      Referral Link:
                    </p>
                    <div
                      className="referral-code-value"
                      onClick={() => handleCopy(referralCode)}
                    >
                      <span className="txt-ellipsis-1">{referralCode}</span>
                      <i className="fa fa-copy"></i>
                    </div>
                    <div className="text-right text-success">
                      {message1 && <span>{message1}</span>}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Rank List */}
            <div className="card border-0">
              <div className="card-header py-3 text-center">
                <h5>Salary Club Income</h5>
              </div>
              <div className="desktop-view-only card-body px-0">
                <div className="table-responsive">
                  <table className="table align-middle mb-0 bg-hover-effect">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        {Object.values(
                          rankList[0]?.displayFields
                            ? JSON.parse(rankList[0].displayFields)
                            : []
                        ).map((thd) => (
                          <th scope="col">{thd}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {rankList?.length > 0 ? (
                        rankList?.map((item, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            {Object.keys(JSON.parse(item?.displayFields)).map(
                              (key) => (
                                <td>
                                  {key == "status" ? (
                                    item.rankid == item.userRank ? (
                                      <span class="badge bg-success me-1 mb-1 mt-1">
                                        Active
                                      </span>
                                    ) : (
                                      <a
                                        type="button"
                                        onClick={() =>
                                          getRankwiseTargetDetailsApp(
                                            item.rankid
                                          )
                                        }
                                        class="badge bg-warning badge-default me-1 mb-1 mt-1 view-targets"
                                      >
                                        Pending
                                      </a>
                                    )
                                  ) : (
                                    <p className="mb-0 f-w-500 ">
                                      {typeof item[key] == "number" ? "$" : ""}
                                      {item[key]}
                                    </p>
                                  )}
                                </td>
                              )
                            )}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={7} className="text-center">
                            No records found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="mobile-view-only">
                {rankList?.length > 0 ? (
                  rankList.map((item, i) => (
                    <div
                      key={i}
                      className={"mb-3 p-3 bg-hover-effect rounded shadow-sm "}
                    >
                      <div className="d-flex justify-content-between align-items-center my-2">
                        <span className="badge bg-dark">#{i + 1}</span>
                      </div>
                      {Object.keys(JSON.parse(item?.displayFields)).map(
                        (key) => (
                          <div className="d-flex justify-content-between align-items-center my-2">
                            <strong>
                              {JSON.parse(item?.displayFields)?.[key]}:
                            </strong>
                            {key == "status" ? (
                              item.rankid == item.userRank ? (
                                <span class="badge bg-success me-1 mb-1 mt-1">
                                  Active
                                </span>
                              ) : (
                                <a
                                  type="button"
                                  onClick={() =>
                                    getRankwiseTargetDetailsApp(item.rankid)
                                  }
                                  class="badge bg-warning badge-default me-1 mb-1 mt-1 view-targets"
                                >
                                  Pending
                                </a>
                              )
                            ) : (
                              <p className="mb-0 f-w-500 ">
                                {typeof item[key] == "number" ? "$" : ""}
                                {item[key]}
                              </p>
                            )}
                          </div>
                        )
                      )}
                    </div>
                  ))
                ) : (
                  <p className="text-center">No records found.</p>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* modals */}
        {showAddMoney && (
          <div
            className="modal fade show"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title mt-0">Add Money</h5>
                  <button
                    type="button"
                    className="btn-close text-light"
                    onClick={() => {
                      setShowAddMoney(false);
                      setAddMoneyAmount("");
                    }}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-lg-8 m-auto mb-2">
                      <div className="mb-3">
                        <label htmlFor="" style={{ color: "#3a2427" }}>
                          Amount:{" "}
                        </label>
                        <input
                          style={{ borderColor: "#813838a8" }}
                          placeholder="Enter amount"
                          defaultValue={addMoneyAmount}
                          onChange={(e) => setAddMoneyAmount(e.target.value)}
                          type="text"
                          className="form-control"
                        />
                      </div>
                      <div className="d-flex justify-content-between">
                        <button
                          onClick={() => fundRequestTo()}
                          className="btn btn-primary-cus2"
                          type="button"
                        >
                          Buy Tether
                        </button>
                        <button
                          onClick={() => initiateAddmoney()}
                          className="btn btn-primary-cus1"
                          type="button"
                        >
                          Connect wallet
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {isManualRequest && (
          <div
            className="modal fade show"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-md modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title mt-0">Buy Tether</h5>
                  <button
                    type="button"
                    className="btn-close text-light"
                    onClick={() => backToInitial()}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-lg-8 m-auto pb-0">
                      <label htmlFor="" style={{ color: "#3a2427" }}>
                        Amount*:{" "}
                      </label>
                      <input
                        style={{ borderColor: "#813838a8" }}
                        placeholder="Enter amount"
                        defaultValue={addMoneyAmount}
                        onChange={(e) => setAddMoneyAmount(e.target.value)}
                        type="text"
                        className="form-control"
                      />
                      {/* </div> */}
                      {/* <div className="col-lg-6 pb-0">
                                            <label htmlFor="" style={{ color: "#3a2427" }}>Utr No*: </label>
                                            <input
                                                style={{ borderColor: "#813838a8" }}
                                                placeholder="Enter utr no"
                                                defaultValue={utrNo}
                                                onChange={(e) => setUtrNo(e.target.value)}
                                                type="text" className="form-control"
                                            />
                                        </div>
                                        <div className="col-lg-6">
                                            <label htmlFor="" style={{ color: "#3a2427" }}>Upload Image: </label>
                                            <input
                                                style={{ borderColor: "#813838a8" }}
                                                value={proofDoc?.fileName}
                                                onChange={(e) => setProofDoc(e.target.files[0])}
                                                type="file" className="form-control"
                                            />
                                        </div> */}
                      {/* <div className="col-lg-12 mb-3"> */}
                      <div className="d-flex justify-content-between my-3">
                        <button
                          onClick={() => addFundOrder()}
                          className="btn btn-primary-cus"
                          type="button"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {isRankWiseTargetDetail && (
          <div
            className="modal fade show"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-md modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header text-center">
                  <h5 className="modal-title mt-0">Rank Target Details</h5>
                  <button
                    type="button"
                    className="btn-close text-light"
                    onClick={() => setIsRankWiseTargetDetail(false)}
                  ></button>
                </div>
                <div className="modal-body p-0 bg-light">
                  <div className="desktop-view-only mx-2 table-responsive">
                    <table className="table align-middle mb-0 bg-hover-effect">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Target Name</th>
                          <th scope="col">Target</th>
                          <th scope="col">Achieved</th>
                          <th scope="col">Remaining</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rankWiseTargetDetail?.length > 0 ? (
                          rankWiseTargetDetail?.map((item, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>
                                {" "}
                                <p className="mb-0 f-w-500 ">
                                  {item.targetName}
                                </p>{" "}
                              </td>
                              <td>
                                {" "}
                                <p className="mb-0 f-w-500 ">
                                  ${item.targetValue}
                                </p>{" "}
                              </td>
                              <td>
                                {" "}
                                <p className="mb-0 f-w-500 ">
                                  ${item.achievedValue}
                                </p>{" "}
                              </td>
                              <td>
                                {" "}
                                <p className="mb-0 f-w-500 ">
                                  ${item.remainingValue}
                                </p>{" "}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={7} className="text-center">
                              No records found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="mobile-view-only">
                    {rankWiseTargetDetail?.length > 0 ? (
                      rankWiseTargetDetail.map((el, i) => (
                        <div
                          key={i}
                          className={
                            "mb-3 p-3 bg-hover-effect rounded shadow-sm "
                          }
                        >
                          <div className="d-flex justify-content-between align-items-center my-2">
                            <span className="badge bg-dark">#{i + 1}</span>
                          </div>

                          <div className="d-flex justify-content-between align-items-center my-2">
                            <strong>Target Name:</strong>
                            <span className="mb-0 f-w-600">
                              {el.targetName}
                            </span>
                          </div>

                          <div className="d-flex justify-content-between align-items-center my-2">
                            <strong>Target:</strong>
                            <span className="mb-0 f-w-600">
                              ${el.targetValue}
                            </span>
                          </div>
                          <div className="d-flex justify-content-between align-items-center my-2">
                            <strong>Achieved:</strong>
                            <p className="mb-0 f-w-500">${el.achievedValue}</p>
                          </div>

                          <div className="d-flex justify-content-between align-items-center my-2">
                            <strong>Remaining:</strong>
                            <p className="mb-0 f-w-600">${el.remainingValue}</p>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p className="text-center">No records found.</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {showWithdrawal && (
          <div
            className="modal fade show"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title mt-0">Select Withdrawal type</h5>
                  <button
                    type="button"
                    className="btn-close text-light"
                    onClick={() => {
                      setShowWithdrawal(false);
                    }}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="d-flex justify-content-evenly my-3">
                    {/* <div className="col-lg-8 m-auto mb-2"> */}
                    {balanceData[0]?.allowedWithdrawalType?.map((item) =>
                      item.isActive ? (
                        // <div className="mb-3 text-center">
                        <button
                          onClick={() => {
                            setShowWithdrawal(false);
                            setWithdrawServiceId(item.serviceId);
                          }}
                          className="btn btn-primary-1"
                        >
                          {item.serviceName}
                        </button>
                      ) : // </div>
                        null
                    )}
                    {/* </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {withdrawServiceId == 76 ? (
          <div
            className="modal fade show"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title mt-0"> Coin Withdrawal</h5>
                  <button
                    type="button"
                    className="btn-close text-light"
                    onClick={() => {
                      setWithdrawServiceId(null);
                    }}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-lg-6 ">
                      <label htmlFor="" style={{ color: "#3a2427" }}>
                        From wallet:{" "}
                      </label>
                      <select
                        className="form-control"
                        value={withdrawFromWalletId}
                        disabled={balanceData[0].allowedWallet?.length <= 1}
                        onChange={(e) => setWithdrawFromWallet(e.target.value)}
                      >
                        <option value="" selected disabled>
                          Select From Wallet
                        </option>
                        {balanceData[0].allowedWallet?.map((el) => (
                          <option value={el.id}>{el.walletName}</option>
                        ))}
                      </select>
                      <div style={{ color: "#a80000ff" }}>
                        {!withdrawFromWalletId
                          ? "From Wallet is required."
                          : ""}
                      </div>
                    </div>
                    <div className="col-lg-6 ">
                      <label htmlFor="" style={{ color: "#3a2427" }}>
                        To Coin:{" "}
                      </label>
                      <select
                        className="form-control border-0"
                        value={withDrawalFromCurrencyId?.symbolName}
                        onChange={(e) => handleAbc(e.target.value)}
                      >
                        {balanceData[0].allowedWalletToCripto?.map((el) => (
                          <option value={el.symbolName}>{el.symbolName}</option>
                        ))}
                      </select>
                      {/* <div style={{ color: "#a80000ff" }}>{!withdrawToWalletId ? 'To Wallet is required.' : ""}</div> */}
                    </div>

                    <div className="col-lg-6">
                      <label htmlFor="" style={{ color: "#3a2427" }}>
                        Transaction Amount:{" "}
                      </label>
                      <input
                        style={{ borderColor: "#813838a8" }}
                        placeholder="Transaction amount"
                        onChange={(e) => setWithDrawalAmt(e.target.value)}
                        type="text"
                        className="form-control"
                      />
                      <div style={{ color: "#a80000ff" }}>
                        {withDrawalError.amount}
                      </div>
                    </div>

                    {showExternalWallet ? (
                      <div className="col-lg-6">
                        <label htmlFor="" style={{ color: "#3a2427" }}>
                          External Address:{" "}
                        </label>
                        <input
                          style={{ borderColor: "#813838a8" }}
                          placeholder="External Address"
                          onChange={(e) =>
                            setWithExternalWallet(e.target.value)
                          }
                          type="text"
                          className="form-control"
                        />
                        <div style={{ color: "#a80000ff" }}>
                          {withDrawalError.address}
                        </div>
                      </div>
                    ) : null}
                    <div className="d-flex justify-content-between mt-2 mb-3">
                      <button
                        onClick={() => walletToWalletWithDraw("coin")}
                        className="btn btn-primary-cus1"
                        type="button"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          withdrawServiceId > 1 && (
            <div
              className="modal fade show"
              style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
            >
              <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title mt-0">
                      Wallet To Wallet Transfer
                    </h5>
                    <button
                      type="button"
                      className="btn-close text-light"
                      onClick={() => {
                        setWithdrawServiceId(null);
                      }}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-lg-6 ">
                        <label htmlFor="" style={{ color: "#3a2427" }}>
                          From wallet:{" "}
                        </label>
                        <select
                          className="form-control"
                          value={withdrawFromWalletId}
                          disabled={balanceData[0].allowedWallet?.length <= 1}
                          onChange={(e) =>
                            setWithdrawFromWallet(e.target.value)
                          }
                        >
                          <option value="" selected disabled>
                            Select From Wallet
                          </option>
                          {balanceData[0].allowedWallet?.map((el) => (
                            <option value={el.id}>{el.walletName}</option>
                          ))}
                        </select>
                        <div style={{ color: "#a80000ff" }}>
                          {!withdrawFromWalletId
                            ? "From Wallet is required."
                            : ""}
                        </div>
                      </div>
                      <div className="col-lg-6 ">
                        <label htmlFor="" style={{ color: "#3a2427" }}>
                          To wallet:{" "}
                        </label>
                        <select
                          className="form-control"
                          value={withdrawToWalletId}
                          disabled={balanceData[0].allowedWallet?.length <= 1}
                          onChange={(e) => setWithdrawToWallet(e.target.value)}
                        >
                          <option value="" selected disabled>
                            Select To Wallet
                          </option>
                          {balanceData[0].allowedWallet?.map((el) => (
                            <option value={el.id}>{el.walletName}</option>
                          ))}
                        </select>
                        <div style={{ color: "#a80000ff" }}>
                          {!withdrawToWalletId ? "To Wallet is required." : ""}
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <label htmlFor="" style={{ color: "#3a2427" }}>
                          Transaction Amount:{" "}
                        </label>
                        <input
                          style={{ borderColor: "#813838a8" }}
                          placeholder="Transaction amount"
                          onChange={(e) => setWithDrawalAmt(e.target.value)}
                          type="text"
                          className="form-control"
                        />
                        <div style={{ color: "#a80000ff" }}>
                          {withDrawalError.name}
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <label htmlFor="" style={{ color: "#3a2427" }}>
                          User Id:{" "}
                        </label>
                        <input
                          style={{ borderColor: "#813838a8" }}
                          placeholder="User Id"
                          onChange={(e) => handleToUserChange(e.target.value)}
                          type="number"
                          className="form-control"
                        />
                        <div style={{ color: "#1f0101" }}>{sponsorName}</div>
                        <div style={{ color: "#a80000ff" }}>
                          {withDrawalError.userId}
                        </div>
                      </div>
                      <div className="d-flex justify-content-between mt-2 mb-3">
                        <button
                          onClick={() => walletToWalletWithDraw()}
                          className="btn btn-primary-cus1"
                          type="button"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        )}
      </main>
    </Layout>
  );
};

export default Dashboard;
